module.exports = __webpack_public_path__ + "media/images/down-arrow-b14df9787347a3d52fa419d39e99de3e.svg";